export class FetchError extends Error {
  constructor (error, message = '') {
    super(message)
    this.data = error
  }
}
